import React from "react";
import {Link, useNavigate} from "react-router-dom";
import AnimatedSkeletons from "./AnimatedSkeletons";
import RoutesPathDefs from "../RoutesPathDefs";
import {hooks, pluralize, TaggedLogger} from "@nextlot/core";
import useListingUrlParams, {serializeFilterStruct} from "../hooks/useListingUrlParams";
import AuctionCard from "./auction/AuctionCardCmp";
import ListingsPagination from "./ListingsPagination";
import SearchLotsForm from "./SearchLotsForm";


const _logger = TaggedLogger.get('AuctionsListCompleted');

export default function AuctionsListCompleted() {

  const navigate = useNavigate();

  const {
    pageNumber, pageSize,
    filters, sortingCriteria,
    generatePathWithParams} = useListingUrlParams();

  const { completed: completedAuctions } = hooks.useRealtimeUpdatingAuctionsList({pageNumber, pageSize,
    filters, sortingCriteria});


  const pagesCount = completedAuctions?.pagesCount || 1;
  const validSafePageNumber = React.useCallback((reqPageNumber:number) => {
    // ensure reqPageNumber is between 1 and pagesCount
    return Math.min(pagesCount, Math.max(1, reqPageNumber));
  }, [completedAuctions, pagesCount]);

  const [inputLotsSearchText, setInputLotsSearchText] = React.useState('')
  const handleChange_inputLotsSearchText = (evt) => {
      setInputLotsSearchText(evt.target.value);
  }
  const handleSubmit_searchLots = (evt) => {
      evt.preventDefault();
      if (inputLotsSearchText) {
          const urlSearchParams = new URLSearchParams({ filters: serializeFilterStruct({ text_search: inputLotsSearchText, auction_completes_at: '-1' }) });
          const navigatePathWithQuery = RoutesPathDefs.toSearchLotsPage.generatePath() + '?' + urlSearchParams.toString();
          navigate(navigatePathWithQuery);
      }
  }

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pageNumber]);


  return (
    <>
      <div className="row pt-5">
        <div className="col">
          <Link to={RoutesPathDefs.toHomePage.generatePath()}>Back to Active Auctions</Link>
        </div>
      </div>
      <div className="row pt-4">
        <div className="col-lg-8 col-12">
          <h1 className="mb-3">Completed Auctions</h1>
        </div>
        <div className="col-lg-4 col-12 d-flex justify-content-start justify-content-lg-end align-items-center">
            <SearchLotsForm
              handleSubmit={handleSubmit_searchLots}
              handleInputChange={handleChange_inputLotsSearchText}
              inputValue={inputLotsSearchText}
            />
        </div>
      </div>

      {
          completedAuctions.isFetching
              ? <AnimatedSkeletons.AuctionsListSkeleton/>
              : completedAuctions.fetchError
                  ? <div>Oops, error!</div>
                  : (
                      completedAuctions.list?.length
                          ? (
                              <div className="row pt-4">
                                <div className="col">
                                    {
                                      completedAuctions.list.map((auction) => <AuctionCard key={auction.id} auction={auction}/>)
                                    }


                                    <div className="py-2 d-flex flex-row justify-content-center justify-content-md-start align-items-center">
                                      <ListingsPagination
                                        generatePathWithParams={generatePathWithParams}
                                        validSafePageNumber={validSafePageNumber}
                                        pageNumber={completedAuctions.pageNumber}
                                        pagesCount={completedAuctions.pagesCount}
                                      />
                                    </div>
                                </div>
                              </div>
                            )
                          : <div><p className='lead'>There are no completed auctions. Please check back again soon.</p></div>
                  )
      }
      <div className="w-100 pt-5 text-center">
        <Link className="btn btn-outline-dark" to={RoutesPathDefs.toHomePage.generatePath()}>View Active Auctions</Link>
      </div>
    </>
  )



}
